// Tên máy đọc từ User-Agent — "Chrome · Windows", "Safari · iPhone"… Hiện ở danh sách phiên đăng nhập (Cài đặt ›
// Bảo mật), màn duyệt đăng nhập bằng mã QR và thông báo đăng nhập mới. Chỉ để người dùng nhận ra máy: User-Agent do
// máy khách tự khai.

/** '' khi không đọc được gì. */
export function describeDevice(ua: string | null | undefined): string {
  if (!ua) return ''
  // Thứ tự quan trọng: Cốc Cốc / Edge / Opera / Samsung cũng ghi "Chrome/", Chrome cũng ghi "Safari/"
  const browser =
    /coc_coc_browser/i.test(ua) ? 'Cốc Cốc'
    : /Zalo/i.test(ua) ? 'Zalo'
    : /FBAN|FBAV|FB_IAB/.test(ua) ? 'Facebook'
    : /Edg(e|A|iOS)?\//.test(ua) ? 'Edge'
    : /OPR\/|Opera/.test(ua) ? 'Opera'
    : /SamsungBrowser/.test(ua) ? 'Samsung Internet'
    : /Firefox\/|FxiOS/.test(ua) ? 'Firefox'
    : /Chrome\/|CriOS/.test(ua) ? 'Chrome'
    : /Version\/[\d.]+.*Safari\//.test(ua) ? 'Safari'
    : ''
  // iPad đời mới xin bản máy tính → khai "Macintosh": không phân biệt được, ghi macOS
  const os =
    /iPad/.test(ua) ? 'iPad'
    : /iPhone|iPod/.test(ua) ? 'iPhone'
    : /Android/.test(ua) ? 'Android'
    : /Windows/.test(ua) ? 'Windows'
    : /Macintosh|Mac OS X/.test(ua) ? 'macOS'
    : /CrOS/.test(ua) ? 'ChromeOS'
    : /Linux/.test(ua) ? 'Linux'
    : ''
  return [browser, os].filter(Boolean).join(' · ')
}
